import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  user: {},
  userPoints: {},
  pageFrom: '',
  isDrugPriceLoad: true,
  isServerSessionExpired: false
};

const authSlice = createSlice({
  name: 'authentication',
  initialState: initialState,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.user.userName = `${action.payload.user?.firstName} ${action.payload.user?.lastName}`;
      state.pageFrom = action.payload.pageFrom;
    },
    clearUserData(state) {
      state.user = {};
    },
    logout(state) {
      state.isLoggedIn = false;
      state.user = {};
      state.userPoints = {};
      state.pageFrom = '';
      state.isDrugPriceLoad = true;
    },
    userpoints(state, action) {
      state.userPoints = action.payload.userPoints;
    },
    pageAction(state, action) {
      state.isDrugPriceLoad = action.payload.isDrugPriceLoad;
    },
    sessionExpired(state, action) {
      state.isServerSessionExpired = action.payload.isServerSessionValid;
    }
  }
});

export const authActions = authSlice.actions;

export default authSlice;
